
(function ($) {
  "use strict";

  jQuery(document).ready(function(){

    /*--
    Menu Sticky
    -----------------------------------*/
    var windows = $(window);
    var sticky = $('.header-sticky');


    windows.on('scroll', function() {
      var scroll = windows.scrollTop();
      if (scroll < 100) {
        sticky.removeClass('is-sticky');

      }else{
        sticky.addClass('is-sticky');

      }
    });
    document.onkeydown = function(e) {
      if(event.keyCode == 123) {
       return false;
     }
     if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
       return false;
     }
     if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
       return false;
     }
     if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
       return false;
     }
     if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
       return false;
     }
   }
     jQuery(document).ready(function($) {
    if($(window).width() > 1024){
      $(window).scroll(function(){
        if ($(window).scrollTop() >= 100) {
          $('.sticky_addcart').addClass('active');
        }
        else {
          $('.sticky_addcart').removeClass('active');
        }
      });
    }
  });
   function initStickPrLeft(){
    var stickprcol = $('.stickprcol-js'),
    stickprcolheight = $('.stickprcolheight-js'),
    o = stickprcol.attr('data-o', stickprcol.offset().top);
    $('body').on('click', '.tt-collapse-title', function(){
      setTimeout(function(){
        setPosition();
      }, 200);
    })
    setTimeout(function(){
      setPosition();
    }, 500);
    $(window).resize(function(){
      stickprcol.css({top: 0});
      o = stickprcol.attr('data-o', stickprcol.offset().top);
      setTimeout(function(){
        setPosition();
      }, 100);
    }).scroll(function(){
      setPosition();
    })
    function setPosition(){
      typeof stickprcol.attr('css') !== typeof undefined && stickprcol.removeAttr('css');
      var h = stickprcol.children().length == 1 ? stickprcol.children().height() : stickprcol.height();
      if(h > $(window).height()) return false;
      if(h > stickprcolheight.height()) return false;

      if($(window).width() < 768) return false;
      var m = 68,
      o = stickprcol.attr('data-o'),
      p = stickprcol.position().top,
      w = $(window).scrollTop(),

      mh = stickprcolheight.height() - h - 10,

      ow = Math.max(0, w-o+m);
      ow = Math.min(mh, ow);

      stickprcol.css({top: ow});
      $('.zoomContainer').length && $('.zoomContainer').css({top: ow+m*2}); 
    }
  }
  $('.stickprcol-js').length && initStickPrLeft();
    /*--
    Mobile Menu
    ------------------------*/
    var menuNav = $('nav.main-navigation');
    menuNav.meanmenu({
      meanScreenWidth: '991',
      meanMenuContainer: '.mobile-menu',
      meanMenuClose: '<span class="menu-close"></span>',
      meanMenuOpen: '<span class="menu-bar"></span>',
      meanRevealPosition: 'right',
      meanMenuCloseSize: '0',
    });
    $(document).ready(function(){
      $("button.navbar-toggler").click(function(){
        $(".menu-mobile").addClass("opened");
        $(".mm-fullscreen-bg").addClass("active");
      });
      $(".close-box").click(function(){
        $(".menu-mobile").removeClass("opened");
        $(".mm-fullscreen-bg").removeClass("active");
      });

      $(".shopping-cart-wrap a").click(function(){
        $(".shopping-widget").addClass("show");
        $(".mm-fullscreen-bg").addClass("active");
      });
      $(".shopping-cart-close i").click(function(){
        $(".shopping-widget").removeClass("show");
        $(".mm-fullscreen-bg").removeClass("active");
      });

      $("a.meanmenu-reveal").click(function(){
        $(".mean-nav").toggleClass("active");
        $(".is-sticky").toggleClass("active-menu");
      });
      $(".newsletterCheck").click(function(){
        $(this).toggleClass("check");
      });
      $(".title-menu").click(function(){
        $(".menu-content").toggleClass("active");
      });
      $(".search-icon").click(function(){
        $(".search-block").addClass("active");
        $('body').addClass("fix");
      });
      $(".search-block-close").click(function(){
        $(".search-block").removeClass("active");
        $('body').removeClass("fix");
      });
    });
    $(document).ready(function(){
      $('[data-toggle="tooltip"]').tooltip();   
    });
    (function ( $ ) {
    $.fn.addClassAndRemove = function(classAdd, timeAdd, timeRemove) {
      let element = this;
      let addIt = function(){
           element.addClass(classAdd);
        };
      let removeIt = function(){
           element.removeClass(classAdd);
        };
      setTimeout(function() { addIt(); setTimeout(removeIt, timeRemove); }, timeAdd);
      return this;
    };
}( jQuery ));
$('.cart-msg').off().click(function(e) {
  $('#snackbar').addClassAndRemove('show', 0, 3000);
});
  /*--
   Sidebar Search Active
   -----------------------------*/
   jQuery(document).on('click','.mobile-version .menu-mobile .main-nav .expand',function(event){
      
      let _title = $(this).parents('.dropdown').first().find('a').first().children().first().text().split('\n')[0];
      let e = $(this).parents('.dropdown').first();

      e.addClass('active');
      e.parent().addClass('sub-open');

      if (e.hasClass('dropdown') ) {
        let child = e.children('.dropdown-menu');
        if(child.length > 0){
          if (child.hasClass('menu-mobile-open') == false) {
            child.addClass('menu-mobile-open');

            if (_title.length > 0) {
              child.children('.back-prev-menu').find('.back').html(_title);
            }
            return false;
          }
        }
      }
      if ($(this).parent().hasClass('back-prev-menu')) {
        let e = $(this).parent();
        let _pa = e.parents('.dropdown').first();

        $(this).parents('.dropdown-menu').first().removeClass('menu-mobile-open');

        _pa.removeClass('active');
        _pa.parent().removeClass('sub-open');
      }
    });

   /*--
   Sidebar Search Active
   -----------------------------*/
   function sidebarSearch() {
    var searchTrigger = $('.trigger-search'),
    endTriggersearch = $('button.search-close'),
    container = $('.main-search-active');

    searchTrigger.on('click', function() {
      container.addClass('inside');
    });

    endTriggersearch.on('click', function() {
      container.removeClass('inside');
    });

  };
  sidebarSearch();



  /*-- Brand Slider --*/
  var blogSlider = $('.blog-image-slider');
  blogSlider.slick({
    arrows: true,
    autoplay: false,
    dots: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScoll: 1,
    prevArrow: '<button type="button" class="slick-prev"> <i class="icon-arrow-left"></i> </button>',
    nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
  });

    /*--
    vertical-product-active
    --------------------------------------*/
    $('.vartical-product-active').slick({
      slidesToShow: 3,
      autoplay: false,
      vertical:true,
      verticalSwiping:true,
      slidesToScroll: 1,
      prevArrow:'<i class="fa fa-angle-up"></i>',
      nextArrow:'<i class="fa fa-angle-down"></i>',
      button:false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      { breakpoint: 991,
       settings: {
         slidesToShow: 3,
         vertical:false,
       }
     },
     {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        vertical:false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        vertical:false,
      }
    }
    ]

  });	     
    $('.vartical-product-active a').on('click', function () {
      $('.vartical-product-active a').removeClass('active');
    });

    /*--
    vertical-product-active
    --------------------------------------*/
    $('.horizantal-product-active').slick({
      slidesToShow: 4,
      autoplay: false,
      vertical:false,
      prevArrow:'<i class="icon-arrow-top arrow-prv"></i>',
      nextArrow:'<i class="icon-arrow-bottom arrow-next"></i>',
      button:false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      { breakpoint: 991,
       settings: {
         slidesToShow: 3,
       }
     },
     {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
      }
    }
    ]

  });	     
    $('.horizantal-product-active a').on('click', function () {
      $('.horizantal-product-active a').removeClass('active');
    });

    
    $('[data-toggle="tooltip"]').tooltip();    
    
    /*--
    Magnific Popup
    ------------------------*/
    $('.img-poppu').magnificPopup({
      type: 'image',
      gallery:{
        enabled:true
      }
    });



/*--
    Accordion
    -------------------------*/
    $(".faequently-accordion").collapse({
      accordion:true,
      open: function() {
        this.slideDown(300);
      },
      close: function() {
        this.slideUp(300);
      }		
    });	

    $(window).scroll(function(){ 
      if ($(this).scrollTop() > 100) { 
        $('#top').fadeIn(); 
      } else { 
        $('#top').fadeOut(); 
      } 
    }); 
    $('#top').click(function(){ 
      $("html, body").animate({ scrollTop: 0 }, 600); 
      return false; 
    });
    /* --
    counterUp 
    -----------------------------*/
    $('.count').counterUp({
      delay: 10,
      time: 1000
    });

  });
})(jQuery);	
